module.exports = __webpack_public_path__ + "static/media/smartAsn-login.c85b41d8.svg";